export default "__VITE_ASSET__KmCnHiZq__"